import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { onPushDataLayer } from "@/utils/events";
import stl from "./AnyQuestion.module.css";
import { trackEvents } from "@/common/events/events";
import useContactNumbers from "@hooks/useContactNumbers";
var AnyQuestion = function AnyQuestion() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contactNumbers = useContactNumbers();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: stl.anyQuestionContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.anyQuestionBox
  }, /*#__PURE__*/React.createElement("h5", {
    className: stl.headerText
  }, t("اذا كنت تريد المساعدة؟", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.ctaBox
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://wa.me/".concat(contactNumbers.whatsappCallNumber),
    rel: "noopener noreferrer",
    target: "_blank",
    className: stl.wpBtn,
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: null,
        contact_type: "whatsapp",
        contact_location: "FAQs"
      });
      onPushDataLayer("event", "communication", "contact_us", "whatsapp");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t('تواصل عبر واتساب', {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(contactNumbers.callCenterDisplayNumber),
    className: stl.callBtn,
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: null,
        contact_type: "call",
        contact_location: "FAQs"
      });
      onPushDataLayer("event", "communication", "contact_us", "call");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Call Us@1Blue.svg",
    alt: "",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("span", null, t('اتصل بنا', {
    ns: "web_common"
  })))))));
};
export default AnyQuestion;